import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import moment from "moment"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const paymentList = createAsyncThunk("payment/list", async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: "GET",
            url: getConfig.API_URL + `payment_management`,
            params: {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                search: data?.search,
                premise_id: data?.premise_id,
                unit_id: data?.unit_id,
            },
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const paymentDetails = createAsyncThunk("payment/details", async ({ id, navigate, month, year_id }) => {
    try {
        const res = await axios({
            method: "GET",
            url: getConfig.API_URL + `payment_management/${id}`,
            params: {
                month: month,
                year_id: year_id,
            },
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const createOnlinePaymentOrder = createAsyncThunk("payment/createOnlineOrder", async ({ data }) => {
    try {
        const res = await axios({
            method: "POST",
            url: getConfig.API_URL + "create_payment_order",
            data,
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const verifyOnlinePayment = createAsyncThunk("payment/verifyOnlinePayment", async ({ data }) => {
    try {
        const res = await axios({
            method: "POST",
            url: getConfig.API_URL + "verify_payment",
            data,
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addOfflinePayment = createAsyncThunk("payment/addOfflinePayment", async ({ data }) => {
    try {
        const res = await axios({
            method: "POST",
            url: getConfig.API_URL + "manual_payment",
            data,
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const allTransactions = createAsyncThunk("payment/allTransactions", async ({ date, navigate }) => {
    try {
        const res = await axios({
            method: "GET",
            url: getConfig.API_URL + "all_transactions",
            params: {
                date: date && moment(date, "DD/MM/YYYY").format("YYYY-MM-DD"),
            },
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const deleteTransaction = createAsyncThunk("payment/deleteTransaction", async (data) => {
    try {
        const res = await axios({
            method: "DELETE",
            url: getConfig.API_URL + `delete_transaction/${data?.id}`,
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

const payment = createSlice({
    name: "payment",
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(paymentList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        })
        builder.addCase(paymentDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        })
    },
})

export default payment.reducer;